import { Config } from '#lib/constants/config.js';
import { EditionsRoutes } from '#lib/websites/editions/constants/routes.js';

export const getEditionUrl = (code: string | null | undefined) =>
	`${Config.Domain}${EditionsRoutes.Artwork}/${code}`;
